export function parseAttachment(attachment, attachmentPaths) {
  let names = [];
  let ids = [];
  if (attachment) {
    try {
      const parsed = typeof attachment === 'string' ? JSON.parse(attachment) : attachment;
      if (Array.isArray(parsed)) {
        names = parsed.map(item => item.name || '');
        ids = parsed.map(item => item.id || '');
      }
    } catch (e) { /* ignore parse error */ }
  }
  let urls = [];
  if (attachmentPaths) {
    urls = String(attachmentPaths).split(',').filter(Boolean);
  }
  return urls.map((url, i) => ({ completePath: url.trim(), name: names[i] || '' ,id:ids[i] || ''}));
}

export function buildAttachmentData(fileList) {
  const items = (fileList || []).filter(Boolean);
  console.log("333333333::::::::::::",{
    attachment: items.length ? JSON.stringify(items.map(f => ({
      id: f.id || f.completePath || f.url || f.path ||  f,
      name: f.name || ''
    }))) : '',
    attachmentPaths: items.map(f => f.completePath || f.url || f.path || f.id || f).filter(Boolean).join(',')
  })
  return {
    attachment: items.length ? JSON.stringify(items.map(f => ({
      id: f.id || f.completePath || f.url || f.path ||  f,
      name: (() => { try { return decodeURIComponent(f.name || ''); } catch { return f.name || ''; } })()
    }))) : '',
    attachmentPaths: items.map(f => f.completePath || f.url || f.path || f.id || f).filter(Boolean).join(',')
  };
}

export function attachmentDisplayValue(fileList) {
  if (!fileList || !fileList.length) return '';
  return fileList.map(f => ({ path: f.completePath || f, name: f.name || '' }));
}
